import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const getDynamicTemplatesByManagementTypeAndCategory = async (
  managementType,
  category
) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/dynamic-template/${category}/${managementType}`
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const documentManagementSearch = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/dynamic/filter`,
      data
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const inspectionManagementSearch = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/dynamic/filter/inspection`,
      data
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const saveDocumentManagement = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/dynamic/header/create`,
      data
    );
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const getHeaderByTdhId = async(tdhId)=>{
  try{
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/dynamic/header/get-by-id/${tdhId}`
    );
    return response.data;

  }catch(e){
    console.error(e);
  }
};

export const updateDocumentManagement = async (tdhId, data) => {
  try {
    const response = await gatewayInstance.put(
      `${SERVICE_ENDPOINT.TRANSPORT}/dynamic/header/update/${tdhId}`,
      data
    );
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const saveInspection = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/dynamic/inspect/create`,
      data
    );
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const updateInspection = async (tdhId, data) => {
  try {
    const response = await gatewayInstance.put(
      `${SERVICE_ENDPOINT.TRANSPORT}/dynamic/inspect/update/${tdhId}`,
      data
    );
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const getInspectionByTdhId = async(tdhId)=>{
  try{
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/dynamic/inspect/get-by-id/${tdhId}`
    );
    return response.data;

  }catch(e){
    console.error(e);
  }
};

export const createFleetCharges = async(data) =>{
  try{
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/dynamic/fleet-charges-creation`,data
    );
    return response.data;
  }catch(e){
    console.error(e);
  }
}

export const getFleetChargesByHeaderId = async(headerId)=>{
  try{
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/dynamic/fleet-charges/get-by-header-id/${headerId}`
    );
    return response.data;
  }
  catch(e){
    console.error(e);
  }
}

export const inactiveFleetCharges = async(data) =>{
  try{
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/dynamic/fleet-charges/inactive`,data
    );
    return response;
  }catch(e){
    console.error(e);
  }
}

export const checkDuplicateInspections = async(data) =>{
  try{
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/dynamic/check-duplicate`,data
    );
    return response.data;
  }catch(e){
    console.error(e);
  }
}


export const getVehicleModalTyreDetails = async(id) =>{
  try{
    const response = await gatewayInstance.get(
        `${SERVICE_ENDPOINT.TRANSPORT}/vehicledetail/get/vehicle/modal-and-tyre/${id}`
    );
    return response.data;
  }catch (error){
    console.error(error);
  }
}

export const getInspectionDriverDetails = async(id) =>{
  try{
    const response = await gatewayInstance.get(
        `${SERVICE_ENDPOINT.TRANSPORT}/employee/driver/by-id/${id}`
    );
    return response.data;
  }catch (error){
    console.error(error);
  }
}


export const getReportTypeDetails = async(dyrId)=>{
  try{
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/report-types/dynamic/by-id/${dyrId}`
    );
    return response.data;
  }
  catch(e){
    console.error(e);
  }
}

export const getInspectionReportStaticData = async(tdhId)=>{
  try{
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/dynamic/inspect-report/static/${tdhId}`
    );
    return response.data;
  }
  catch(e){
    console.error(e);
  }
}

export const getInspectionReportDynamicData = async(tdhId)=>{
  try{
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/dynamic/inspect-report/dynamic/${tdhId}`
    );
    return response.data;
  }
  catch(e){
    console.error(e);
  }
}


export const getJobSearchDropdown = async (search) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/dynamic/job-dropdown-search`,
       search
    );

    const uniqueItems = response.data.filter(
      (item, index, array) =>
        index === array.findIndex((findItem) => findItem.id === item.id),
    );

    return uniqueItems.map((item) => ({
      key: item.id,
      title: item.text,
      value: item.value,
    }));
  } catch (e) {
    console.error(e);
  }
};